<template>
    <div class="container-wc">
        <el-tabs v-model="tabActivated">
            
            <el-tab-pane label="ENTREGA" name="entrega">

                <el-collapse v-model="activeNames">
                    
                    <el-collapse-item title="PUNTO DE RETIRO SELECCIONADO" name="1">
                        <div v-if="dataPtoRetiro">
                            <PuntoRetiro :data="dataPtoRetiro"/>
                        </div>
                        <div v-else-if="dataPtoRetiro === null" 
                             v-loading="true"
                             element-loading-text="Cargando..."
                             element-loading-spinner="el-icon-loading"
                             style="height:100px;"></div>  
                        <div v-else >
                            <table class="table table-sm table-bordered table-striped">
                                <tbody style="text-align: left;">
                                    <tr>
                                        <td colspan="3" style="text-align: center;">
                                            No se encontró información del punto de retiro.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                         </div>  
                    </el-collapse-item>

                    <el-collapse-item title="SEGUIMIENTO DE LA GUÍA/REMITO" name="2" >
						<div v-if="seguimiento" :style="heightSeguimiento" >
                            <SeguimientoGuia :seguimiento="seguimiento"/>						
						</div> 
                        <div v-else 
                             v-loading="true"
                             element-loading-text="Cargando..."
                             element-loading-spinner="el-icon-loading"
                             style="height:100px;"></div>                  
                       
                    </el-collapse-item>

                    <el-collapse-item title="CAMBIO DE ESTADO SELLER CENTER" name="3" >
                        <div v-if="cambiosEstados" >                            
                            <CambioEstadoSellerCenter :cambiosEstados="cambiosEstados"/>
                        </div>
                        <div v-else 
                             v-loading="true"
                             element-loading-text="Cargando..."
                             element-loading-spinner="el-icon-loading"
                             style="height:100px;"></div>  
                    </el-collapse-item>
                    
                    <el-collapse-item title="ESTADO DE LA GUÍA/REMITO" name="4" >
                        <div v-if="guia" >                            
                            <EstadoGuia :guia="guia"/>
                        </div>
                        <div v-else 
                             v-loading="true"
                             element-loading-text="Cargando..."
                             element-loading-spinner="el-icon-loading"
                             style="height:100px;"></div>  
                    </el-collapse-item>

                </el-collapse>

            </el-tab-pane>

            <el-tab-pane label="PAGO" name="pago">

                <el-collapse class="facturacion-item" v-model="activePago">

                    <el-collapse-item title="FACTURACIÓN" name="1">
                        <div v-if="dataFacturacion">
                            <Facturacion :data="dataFacturacion"/>
                        </div>                   
                    </el-collapse-item>

                </el-collapse>

            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    import { HTTP } from "@/axios.js"

    export default {
        components: {
            CambioEstadoSellerCenter: () => import(/* webpackChunkName: "CambioEstadoSellerCenter" */ '@/components/CambioEstadoSellerCenter'),
            EstadoGuia              : () => import(/* webpackChunkName: "EstadoGuia" */               '@/components/EstadoGuia'),
            Facturacion             : () => import(/* webpackChunkName: "Facturacion" */              '@/components/Facturacion'),
            PuntoRetiro             : () => import(/* webpackChunkName: "PuntoRetiro" */              '@/components/puntoRetiro'),
            SeguimientoGuia         : () => import(/* webpackChunkName: "SeguimientoGuia" */          '@/components/SeguimientoGuia'),
        },
        props: {
            pedido: {
                required: true
            }
        },
        data() {
            return {
                activeNames       : ['1','2','3','4'],
                activePago        : ['1'],
                cambiosEstados    : null,
                dataFacturacion   : null,
                dataPtoRetiro     : null,
                guia              : null,
                heightSeguimiento : 'height:200px !important;',                
                seguimiento       : null,
                tabActivated      : 'entrega',
            }
        },
        created() {           
            this.getInformation()
            this.getPuntoRetiro()           
        },
        watch: {
            pedido() {
                this.getInformation() 
                this.getPuntoRetiro()
            },

            seguimiento() {
                this.heightSeguimiento = this.seguimiento.length === 0 ? '' : 'height:200px !important; overflow-y: scroll !important;'
            },
        },
        methods: {
            
             getPuntoRetiro() {
   
                HTTP.post( '/getPuntoRetiro', { idVtex: this.pedido })
                      .then( ({ data }) => this.dataPtoRetiro = data != -1 ? data : false )
                      .catch( (err) => console.log(err))
            },

            getInformation() {

                HTTP.post('/getGuideInformation', { tipo: 'pedido', idvtex: this.pedido })
                        .then(( { data }) => {
                            this.dataFacturacion = data[0]
                            const {seguimiento, cambios_estado, guia} = data[0]
                            
                            this.cambiosEstados = cambios_estado ? cambios_estado : []
                            this.guia           = guia           ? guia.filter( g => g != null) : []
                            this.seguimiento    = seguimiento    ? seguimiento[0] : []
                        })
                        .catch( err => console.log(err) )
            },                    
        },
        filters: {
           
        }
    }
</script>

<style lang="scss">
    .container-wc {
        background  : #F6F6F6;
        border      : 1px solid #b1b1b1;
        margin      : 10px;
    }
    .el-collapse-item__arrow {
        font-size   : 15px;
        font-weight : 600;
        margin      : 0 !important;
        transition  : transform .3s;
    }
    .titulo-seg {
        text-align: center !important;        
    }
    .el-collapse-item__header {
        align-items     : center;
        background-color: #FFF;
        border-bottom   : 1px solid #EBEEF5;
        color           : #303133;
        cursor          : pointer;
        display         : flex;
        font-size       : 13px;
        font-weight     : 900;
        height          : 30px;
        line-height     : 48px;
        outline         : 0;
        padding         : 10px 5px;
        transition      : border-bottom-color .3s;
    }
    .el-collapse-item__content {
        color           : #303133;
        font-size       : 13px;
        padding-bottom  : 0px;
    }
  
    .el-collapse-item .is-active {
        background  : #C7E7F3;
        color       : #0A64A4;
        font-weight : 900;
    
    }

    .facturacion-item > .el-collapse-item .is-active {        
        background  : #F48FB1;
        color       : #0A64A4;
        font-weight : 900;
    
    }

    .el-tabs__header {
        margin  : 0px;
        padding : 0px 0px !important;
    }
    .el-tabs__item {
        box-sizing  : border-box;
        color       : #303133;
        display     : inline-block;
        font-size   : 14px;
        font-weight : 900;
        height      : 40px;
        line-height : 40px;
        list-style  : none;
        padding     : 0 5px;
        position    : relative;
    }
    .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), 
    .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), 
    .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), 
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
        padding-left: 5px;
    }
  
</style>